import './mensalTabloide.css'
export default function MensalTabloide () {

	const texts = {
		title: "Quer ficar por dentro das ofertas?",
		subtitle: "Acompanhe nosso tabloide mensal:",
		description: "Aqui na Coocerqui Drogaria você sempre encontra as melhores ofertas. Confira agora o nosso tabloide mensal!"
	}

	const tabloideImgLinks = {
		page_1: "/tabloide/imgs/1.webp",
		page_2: "/tabloide/imgs/2.webp",
		page_3: "/tabloide/imgs/3.webp",
	}

	return (
		<div className="flex-tabloide">
			<div className="left-tabloide">
				<h1>{texts.title}</h1>
				<h2>{texts.subtitle}</h2>
				<p>{texts.description}</p>

				<button>
					<a target='_blank' href="/tabloide">QUERO VER AS OFERTAS</a>
					<i className="fa fa-search"></i>
				</button>

			</div>
			<div className="right-tabloide">
				<figure>
					<img src={tabloideImgLinks.page_1} alt="" />
				</figure>
				<figure>
					<img src={tabloideImgLinks.page_2} alt="" />
				</figure>
				<figure>
					<img src={tabloideImgLinks.page_3} alt="" />
				</figure>
			</div>
		</div>
	)
}